<app-header
  (go-back)="goToMain()"
  [title]="getToolbarTitle()"
></app-header>

<div class="container">
  <div class="selected-image-area">
    <img alt="The image that was chosen to be excluded from the overall license of the resulting file" 
    i18n-alt [src]="getCurrentlySelectedImageFromFile()[0].base64.toString()">
  </div>
  <h1 style="text-align: center;" i18n>Exclude from License</h1>


  <form [formGroup]="formGroup" fxLayout="column" fxLayoutAlign="space-around stretch" (submit)="excludeImage()">
    <h2 i18n>Please enter a description of the image</h2>
    <mat-form-field appearance="fill">
      <mat-label i18n>Description {{this.getTextFieldLabel()}}</mat-label>
      <input
        matInput
        formControlName="description"
        i18n-placeholder
        placeholder="e.g. Logo of RWTH Aachen"
      />
    </mat-form-field>
      <mat-checkbox formControlName="withoutMention" (ngModelChange)="this.formGroup.get('withoutMention').value ? this.formGroup.get('description').disable() : this.formGroup.get('description').enable()"
      class="withoutMentionCheckbox"
      matTooltip="If you select this option, NO mention that this image has been excluded will be added to your file."
      i18n-matTooltip
      i18n>Exclude without mention</mat-checkbox>
      <br/>
    <!-- Success response...
    <h1 *ngIf="showMessageToUser">Modification was successful.</h1> -->

    <button mat-raised-button color="{{this.formGroup.get('withoutMention').value ? 'accent' : 'primary'}}"
    [disabled]="this.formGroup.get('description').value == null && !this.formGroup.get('withoutMention').value"
    >{{this.getButtonText()}}</button>
  </form>
</div>
